// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2cbPY","inputWrap":"Table_inputWrap__3EwAf","col":"Table_col__3Ra_r","bmiTooltip":"Table_bmiTooltip__2vXGh"};